<template>
	<div class="ao-collapse d-flex flex-column w-100">
		<div
			class="d-flex align-center cursor-pointer"
			@click="toggleShowContent(true)"
		>
			<slot
				name="activator"
				:showContent="showContent"
			/>
		</div>
		<div
			ref="collapse"
			class="ao-collapse-content"
		>
			<slot
				name="content"
				:showContent="showContent"
			/>
		</div>
	</div>
</template>

<script>
/**
 * @deprecated Use AoExpansionPanel instead
 */
export default {
	name: 'AoCollapse',
	props: {
		show: {
			type: Boolean,
			default: true,
		},
	},
	emits: {
		'update:show': null,
	},
	data: () => ({
		showContent: true,
	}),

	mounted() {
		if(this.show){
			this.showContent=true
			this.$refs.collapse.style.maxHeight = this.showContent ? `${this.$refs.collapse.scrollHeight}px` : '0px'
		}else{
			this.showContent=false
			this.$refs.collapse.style.maxHeight = '0px';
		}
	},
	methods: {
		toggleShowContent() {
			this.showContent = !this.showContent
			this.callMaxHeight()
			this.$emit('update:show', this.showContent)
		},
		async callMaxHeight() {
			await this.$nextTick(() => {
				if (this.showContent) {
					this.$refs.collapse.style.maxHeight = `${this.$refs.collapse.scrollHeight}px`
					setTimeout(() => {
						this.$refs.collapse.style.maxHeight = 'none'
					}, 350)
				} else {
					this.$refs.collapse.style.maxHeight = `${this.$refs.collapse.scrollHeight}px`
					setTimeout(() => {
						this.$refs.collapse.style.maxHeight = '0px'
					}, 0)
				}
			})
		},
	},
}
</script>

<style lang="scss">
.ao-collapse {
	width: 100%;

	&-content {
		overflow: hidden;
		transition: max-height linear 0.3s;
	}
}
</style>
